import React from "react";
import MapSection from "../components/Map/MapSection";
import KeyPorts from "../components/KeyPorts/KeyPorts";
const Delivery = () => {
  return (
    <div>
      <MapSection />
      <KeyPorts />
    </div>
  );
};

export default Delivery;
